<template>
    <div>
        <div class="action-table-web" v-if="$detect == 'web'">
            <div class="row">
                <div class="col-6">
                    <div class="row">
                        <div class="col-6" v-if="showFilterDate">
                            <ldc-dropdown
                                trigger="click"
                                :action-close="true">
                                <button type="button"
                                        class="btn btn-primary btn-time time-date btn-block bg-white fs-14px text-left pl-10px">
                                    <div class="text-dark" v-if="this.date.day_form === '' && this.date.day_to === ''">Lọc theo ngày</div>
                                    <div v-else>
                                        <div v-if="showTime" class="text-dark">
                                            <div class="text-center">
                                                {{this.$getDate(this.date.day_form)}} <span class="mx-2">-</span> {{this.$getDate(this.date.day_to)}}
                                            </div>
                                        </div>
                                        <div v-else>Lọc theo ngày</div>
                                    </div>
                                </button>
                                <ldc-dropdown-menu>
                                    <div class="fillter-time">
                                        <div class="d-flex">
                                            <div class="w-50 pr-2">
                                                <p class="mb-0 text-label-time mb-1 fs-12px">Từ ngày</p>
                                                <input type="date" class="input-date fs-14px py-1 px-10px" v-model="date.day_form"/>
                                            </div>
                                            <div class="w-50 pl-2">
                                                <p class="mb-0 text-label-time mb-1 fs-12px">Đến ngày</p>
                                                <input type="date" class="input-date fs-14px py-1 px-10px" v-model="date.day_to"/>
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <div class="w-75 pr-2">
                                                <div class="btn-confirm-time mt-10px">
                                                    <button class="text-uppercase btn btn-primary btn-block fs-12px"
                                                            close-dropdown
                                                            @click="emitModel(), showTime = true">Áp dụng</button>
                                                </div>
                                            </div>
                                            <div class="w-25 pl-2">
                                                <div class="btn-cancel-time mt-10px">
                                                    <button class="text-uppercase btn btn-block fs-12px"
                                                            close-dropdown
                                                            @click="showTime = false,
                                                                date.day_form = '',
                                                                date.day_to = '',
                                                                emitModel()"
                                                    >xoá</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ldc-dropdown-menu>
                            </ldc-dropdown>
                        </div>
                        <div class="col-6">
                            <ldc-select
                                v-model="data.type"
                                filterable
                                placeholder="Chọn hình thức">
                                <ldc-option
                                    v-for="(item, index) in categories" :key="index"
                                    :value="index"
                                    :label="`${item}`"/>
                            </ldc-select>
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <div class="row">
                        <div class="col-9">
                            <div class="search position-relative">
                                <input type="text" class="w-100 bg-white fs-14px" placeholder="Nhập #id để tìm kiếm"
                                       v-model="keyword" @keyup.enter="enterKeyword()"/>
                                <div class="btn-search position-absolute">
                                    <span class="lable-search px-10px" @click="enterKeyword()">
                                        <i class="icon ion-ios-search fs-20px"></i>
                                    </span>
                                </div>
                                <div class="text-warning-search fs-10px position-absolute">
                                    * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> )
                                </div>
                            </div>
                        </div>
                        <div class="col-3">
                            <button class="btn btn-block border-0 fs-14px btn-cancel-filter" style="height: 35px;"
                                    @click="removeFillter()">Bỏ lọc</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="action-table-mobile">
                <div input-search>
                    <div content-input-search class="search-box position-relative">
                        <input type="text" placeholder="Nhập id hoặc tiêu đề tin"
                               v-model="keyword" @keyup.enter="enterKeyword()"/>
                        <div class="text-warning-search fs-10px"> * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> ) </div>
                    </div>
                </div>
                <div class="d-flex mb-10px">
                    <div class="w-50 pl-1">
                        <button type="button" class="btn btn-primary time-date btn-block bg-white fs-14px pl-10px"
                                @click="fillterMobile = true">
                            <i class="icon ion-ios-options fs-18px mr-2"></i>Lọc nâng cao
                        </button>
                    </div>
                </div>
            </div>
            <ldc-model-mobile
                titileCancel="Hủy"
                :showCancel="false"
                :showTitle="true"
                title="Lọc tin lịch sử nạp điểm"
                :customButton="true"
                :visible.sync="fillterMobile">
                <div slot="content-model"
                     :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div class="item-fillter" role="button">
                        <ldc-select-mobile
                            placeholder="Chọn hình thức"
                            title="Hình thức"
                            v-model="data.type">
                            <ldc-option-mobile
                                v-for="(item, index) in categories" :key="index"
                                :value="index"
                                :label="`${item}`"/>
                        </ldc-select-mobile>
                    </div>
                    <div class="fillter-date text-left mt-3" v-if="showFilterDate">
                        <div class="tilte-date px-10px pb-2">
                            Lọc theo ngày
                        </div>
                        <div class="fillter">
                            <div class="d-flex">
                                <div class="w-50 pl-10px pr-10px">
                                    <p class="mb-0 text-label-time fs-12px">Từ ngày</p>
                                    <input type="date" class="input-date fs-14px py-1 px-10px"
                                           :placeholder="date.day_form !== '' ? '' : 'Chọn ngày'"
                                           v-model="date.day_form"/>
                                </div>
                                <div class="w-50 pr-10px pl-10px">
                                    <p class="mb-0 text-label-time fs-12px">Đến ngày</p>
                                    <input type="date" class="input-date fs-14px py-1 px-10px"
                                           :placeholder="date.day_to !== '' ? '' : 'Chọn ngày'"
                                           v-model="date.day_to"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div slot="custom-buttom"
                     :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div :class="{
                        'btn-confirm-android': $isAndroid,
                        'btn-confirm-ios mb-10px': !$isAndroid
                        }">
                        <button class="btn btn-primary radius-ios text-uppercase mr-10px fs-14px btn-apply"
                                @click="emitModel()" close-model-mobile>áp dụng</button>
                        <button class="btn btn-light radius-ios text-uppercase ml-10px fs-14px btn-cancel"
                                @click="removeFillter()" close-model-mobile>Bỏ lọc</button>
                    </div>
                </div>
            </ldc-model-mobile>
        </div>
        <actionDialog
            :multiple="true"
            :action="action"
            :visible.sync="dialog"
            :dataMultiple="idSelect"/>
    </div>
</template>
<script>
export default {
    props: ['value', 'idSelect'],
    components: {
        actionDialog: () => import('@/components/profile/raovat/actionDialog.vue'),
    },
    data(){
        return {
            categories: [],
            fillters: [],
            data: {
                type: this.$route.query.type ? this.$route.query.type*1 : '',
            },
            date: {
                day_form: '',
                day_to: '',
            },
            keyword: this.$route.query.keyword,
            showTime: false,
            showActionMuti: false,
            fillterMobile: false,
            dialog: false,
            action: '',
            showFilterDate: true,
            loading: false,
        }
    },
    watch: {
        data:{
            handler(val){
                if(this.$detect == 'web'){
                    this.emitModel();
                }
            },
            deep: true,
        },
        value: {
            handler(val){
                this.changeValue();
            },
            deep: true,
        }
    },
    created() {
        this.changeValue();
        apiGet('/v2/profile/money/money-type').then(res => {
            this.categories = res.data;
        })
    },
    methods: {
        changeValue(){
            this.data.type = this.value.type ? this.value.type : '';
            this.keyword = this.value.keyword ? this.value.keyword : '';
            this.date.day_form = this.value.day_form ? this.value.day_form : '';
            this.date.day_to = this.value.day_to ? this.value.day_to : '';
            if(this.date.day_to != "" && this.date.day_form != ''){
                this.showTime = true
            }
        },
        enterKeyword(){
            if(this.keyword.length < 3 && this.keyword.length > 0) return;
            this.emitModel();
        },
        emitModel(){
            let data = {
                type: this.data.type,
                keyword: this.keyword,
                day_form :  this.date.day_form,
                day_to :  this.date.day_to
            }
            if(this.data.page) data.page = this.data.page;
            this.$emit('input', data)
        },
        removeFillter(){
            this.data = {
                type: '',
            }
            this.date = {
                day_form: '',
                day_to: '',
            }
            this.keyword = '';
            this.emitModel();
        },
    },
}
</script>
